import { useState } from 'react';
import customerModel from '../Customer.model';
import QuoteModel from './QuoteProduct.model';
import SupplierModel from './Supplier.model';

const ProposalModel = () => {
  const initialState = {
    id: 0,
    quoteCode: '',
    customer: customerModel().initialState,
    quoteAttn: '',
    priceGstInclude: false,
    notes: 'some random ',
    user: {},
    createdDate: null,
    updatedDate: null,
    closeDate: null,
    state: 'PENDING', // PENDING, SAVED, PIPELINE, WON, LOST, UPDATED
    currentSupplier: SupplierModel().initialState,
    competeQuote: true,
    salesPerson: {},
    quoteProducts: [QuoteModel().initialState],
    offers: [],
    termAndConditions: [],
    standardTotal: {
      id: 0,
      currentSupplierInformation: {
        id: 0,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      gpInformation: {
        id: 0,
        avgOfGpRequired: 0,
        avgOfCurSupplierGp: 0,
      },
      totalInformation: {
        id: 0,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      savingsInBuyingFromJaybel: {
        id: 0,
        overallSavingDollar: 0,
        overallSavingPercent: 0,
        totalAnnualSavingDollar: 0,
      },
    },
    alternateTotal: {
      id: 0,
      currentSupplierInformation: {
        id: 0,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      gpInformation: {
        id: 0,
        avgOfGPRequired: 0,
        avgOfCurSupplierGP: 0,
      },
      totalInformation: {
        id: 0,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      savingsInBuyingFromJaybel: {
        id: 0,
        overallSavingDollar: 0,
        overallSavingPercent: 0,
        totalAnnualSavingDollar: 0,
      },
    },
  };

  const [proposal, setProposal] = useState(initialState);

  const nullifyAlternateProductInfo = (product) => ({
    ...product,
    alternateProduct: null,
    alternateProductQuantity: 1,
    alternateProductUnitDiviser: 1,
    alternateProductQuotePrice: null,
    alternateProductJaybelPrice: null,
    alternateProductJaybelPriceTotal: null,
    alternateProductCurrentSupplierPrice: null,
    alternateProductCurrentSupplierGp: null,
    alternateProductCurrentSupplierTotal: null,
    alternateProductGpRequired: null,
    alternateProductSaving: null,
    alternateProductTotal: null,
  });

  const nullifyAlternateProductInfoInQuotes = (quoteProducts) =>
    quoteProducts.map(nullifyAlternateProductInfo);

  const nullifyAlternateTotal = (proposal) => ({
    ...proposal,
    alternateTotal: {
      id: proposal.alternateTotal.id,
      currentSupplierInformation: {
        id: proposal.alternateTotal.currentSupplierInformation.id,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      gpInformation: {
        id: proposal.alternateTotal.gpInformation.id,
        avgOfGPRequired: 0,
        avgOfCurSupplierGP: 0,
      },
      totalInformation: {
        id: proposal.alternateTotal.totalInformation.id,
        subtotal: 0,
        gstTotal: 0,
        total: 0,
      },
      savingsInBuyingFromJaybel: {
        id: proposal.alternateTotal.savingsInBuyingFromJaybel.id,
        overallSavingDollar: 0,
        overallSavingPercent: 0,
        totalAnnualSavingDollar: 0,
      },
    },
  });

  return {
    proposal,
    setProposal,
    initialState,
    nullifyAlternateProductInfoInQuotes,
    nullifyAlternateTotal,
  };
};

export default ProposalModel;
